import { createFileRoute } from '@tanstack/react-router'
import { CopilotSuggestionDetailPage } from '@/features/copilot/detail-page'

export const Route = createFileRoute(
  '/_authenticated/copilot/$instanceId/suggestions/$suggestionId'
)({
  component: CopilotSuggestionDetailRoute,
})

function CopilotSuggestionDetailRoute() {
  const { instanceId, suggestionId } = Route.useParams()
  const numericInstanceId = Number(instanceId)
  const numericSuggestionId = Number(suggestionId)

  return (
    <CopilotSuggestionDetailPage
      instanceId={numericInstanceId}
      suggestionId={numericSuggestionId}
    />
  )
}
